import { BaseApiService } from '@/_services/baseApi.service'

export class CourseService extends BaseApiService {
  constructor () {
    super()
  }

  getById (id) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/course/${id}`
    return this.sendGetRequest(url)
  }

  _delete (id) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/course/${id}`
    return this.sendDeleteRequest(url)
  }

  create (data) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/course/create`
    return this.sendPostRequest(url, data)
  }

  edit (data) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/course/edit/${data.id}`
    return this.sendPostRequest(url, data)
  }

  listBySchool (id, title = '', page, size) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/course/school/${id}/list?title=${title}&page=${page}&size=${size}`
    return this.sendGetRequest(url)
  }

  getAllCourseHourId (courseId) {
    // GET /api/v1/class_course/course/{course_id}
    const url = `${process.env.VUE_APP_BASE_URL}/v1/class_course/course/${courseId}`
    return this.sendGetRequest(url)
  }

  updateCourseHourArray (data) {
    // POST /api/v1/class_course/create-massive
    const url = `${process.env.VUE_APP_BASE_URL}/v1/class_course/create-massive`
    return this.sendPostRequest(url, data)
  }
  deleteCourseHour (id) {
      // DELETE /api/v1/class_course/{id}
      const url = `${process.env.VUE_APP_BASE_URL}/v1/class_course/${id}`
      return this.sendDeleteRequest(url)
  }
}
